import { useRef, useState } from 'react';
import RemoveButton from '../../../ui/ButtonClose';
import { ImageCarouselProps } from '@/types';
import { buildImageUrl } from '@/api/buildImageUrl'; // Helper centralizado

/**
 * 🖼️ ImageCarousel
 * Carrusel horizontal de imágenes con arrastre y opción de eliminar.
 */
const ImageCarousel: React.FC<ImageCarouselProps> = ({ images, onRemoveImage, showNoImagesText }) => {
  const carouselRef = useRef<HTMLDivElement>(null);

  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e: React.MouseEvent) => {
    if (!carouselRef.current) return;
    setIsDragging(true);
    setStartX(e.pageX - carouselRef.current.offsetLeft);
    setScrollLeft(carouselRef.current.scrollLeft);
  };

  const handleMouseLeaveOrUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDragging || !carouselRef.current) return;
    e.preventDefault();
    const x = e.pageX - carouselRef.current.offsetLeft;
    const walk = (x - startX) * 2; // velocidad scroll
    carouselRef.current.scrollLeft = scrollLeft - walk;
  };

  if (!images || images.length === 0) {
    return showNoImagesText ? (
      <div className="text-center dark:text-zinc-500 py-1">
        No hay imágenes disponibles.
      </div>
    ) : null;
  }

  return (
    <div
      className="relative w-full overflow-x-auto cursor-grab"
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeaveOrUp}
      onMouseUp={handleMouseLeaveOrUp}
      onMouseMove={handleMouseMove}
      ref={carouselRef}
    >
      <div className="flex gap-3 py-2">
        {images.map((image, index) => {
          let imageUrl = image.imagen_trabajo_realizado;

          // Si es una URL local, no usar buildImageUrl
          if (
            imageUrl?.startsWith("blob:") ||
            imageUrl?.startsWith("data:") ||
            imageUrl?.startsWith("http://localhost") ||
            imageUrl?.startsWith("https://localhost")
          ) {
            // usar tal cual
          } else {
            imageUrl = buildImageUrl(imageUrl);
          }

          return (
            <div
              key={index}
              className="relative w-16 h-8 flex-shrink-0 rounded-md overflow-hidden border border-gray-300 bg-black"
            >
              <img
                src={imageUrl}
                alt={`imagen ${index + 1}`}
                className="w-full h-full object-contain"
              />

              {onRemoveImage && (
                <RemoveButton
                  onClick={() => onRemoveImage(index)}
                  className="absolute top-0 right-0 rounded-sm z-10 dark:text-zinc-900"
                />
              )}
            </div>
          );
        })}

      </div>
    </div>
  );
};

export default ImageCarousel;
